/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum ScheduleConfirmationAliases {
  CONTEXTUAL_BAR_APPOINTMENTS = 'contextual-bar-appointments',
  CONTEXTUAL_BAR_REQUEST = 'contextual-bar-request',
  CONTEXTUAL_BAR_WAITINGLIST = 'contextual-bar-waitinglist',
  FRAGMENT_APPOINTMENT_DETAIL_SUMMARY_APPOINTMENT_SCHEDULE_CONFIRMATION = 'fragment-appointment-detail-summary-appointment-schedule-confirmation',
  FRAGMENT_APPOINTMENT_DETAIL_SUMMARY_REQUEST_SCHEDULE_CONFIRMATION = 'fragment-appointment-detail-summary-request-schedule-confirmation',
  FRAGMENT_APPOINTMENT_DETAIL_SUMMARY_WAITING_LIST_SCHEDULE_CONFIRMATION = 'fragment-appointment-detail-summary-waiting-list-schedule-confirmation',
  FRAGMENT_PRINT_MODAL_SCHEDULE_CONFIRMATION = 'fragment-print-modal-schedule-confirmation',
  LAYOUT_APPOINTMENT_DETAIL = 'layout-appointment-detail',
  LAYOUT_APPOINTMENT_DETAIL_CONTENT_SCHEDULE_CONFIRMATION = 'layout-appointment-detail-content-schedule-confirmation',
  LAYOUT_CONFIRMATION = 'layout-confirmation',
  PANEL_APPOINTMENT_DETAIL_SCHEDULE_CONFIRMATION = 'panel-appointment-detail-schedule-confirmation',
  PANEL_APPOINTMENT_INNER_SCHEDULE_CONFIRMATION = 'panel-appointment-inner-schedule-confirmation',
  PANEL_APPOINTMENTS = 'panel-appointments',
  PANEL_AWAITINGLIST = 'panel-awaitinglist',
  PANEL_CONTEXTUALBAR_APPOINTMENTS = 'panel-contextualbar-appointments',
  PANEL_CONTEXTUALBAR_REQUESTS = 'panel-contextualbar-requests',
  PANEL_CONTEXTUALBAR_WAITINGLIST = 'panel-contextualbar-waitinglist',
  PANEL_PRINT_MODAL_SCHEDULE_CONFIRMATION = 'panel-print-modal-schedule-confirmation',
  PANEL_SCHEDULES = 'panel-schedules',
  ROUTE_PRINT_MODAL_SCHEDULE_CONFIRMATION = 'route-print-modal-schedule-confirmation',
}
export { ScheduleConfirmationAliases };
